import { render } from "./InfoView.vue?vue&type=template&id=e10d3332&scoped=true"
import script from "./InfoView.vue?vue&type=script&lang=js"
export * from "./InfoView.vue?vue&type=script&lang=js"

import "./InfoView.vue?vue&type=style&index=0&id=e10d3332&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e10d3332"

export default script